import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import cartReducer from "./slices/cartSlice";
import homeReducer from "./slices/homeSlice";
import paymentReducer from "./slices/paymentSlice";
import orderReducer from "./slices/orderSlice";
import shippingReducer from "./slices/addressSlice";
import onboardingReducer from "./slices/onboardingSlice";
import stepReducer from "./slices/stepSlice";

const appReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  home: homeReducer,
  orders: orderReducer,
  payment: paymentReducer,
  shipping: shippingReducer,
  onboarding: onboardingReducer,
  steps: stepReducer,
});



// Configure store
export const store = configureStore({
  reducer: appReducer,
  devTools: process.env.NEXT_PUBLIC_NODE_ENV !== "production",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
